import { useLocation, useParams } from "react-router-dom";

const DebugPage = () => {
  // Get query parameters using useLocation
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  // Get route parameters using useParams
  const pathParams = useParams();

  return (
    <div className="container">
      <div style={{ padding: "20px" }}>
        <h2>Parameter Debug Page</h2>

        <div>
          <h3>Query Parameters:</h3>
          {Array.from(queryParams.entries()).length > 0 ? (
            <ul>
              {Array.from(queryParams.entries()).map(([key, value]) => (
                <li key={key}>
                  <strong>{key}:</strong> {value}
                </li>
              ))}
            </ul>
          ) : (
            <p>No query parameters found</p>
          )}
        </div>

        <div>
          <h3>Path Parameters:</h3>
          {Object.keys(pathParams).length > 0 ? (
            <ul>
              {Object.entries(pathParams).map(([key, value]) => (
                <li key={key}>
                  <strong>{key}:</strong> {value}
                </li>
              ))}
            </ul>
          ) : (
            <p>No path parameters found</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default DebugPage;
